import { useEffect, useState } from 'react';

/**
 * useNow — the current time (epoch ms), re-rendering every `intervalMs`.
 * Used to flip time-gated UI (e.g. the Join button unlocking 15 minutes before
 * a class) without a manual refresh.
 */
export default function useNow(intervalMs = 30 * 1000) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
